import React, { useEffect, useState } from "react"
import "./AddProgram.scss"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import Country from "../../../utils/Data/Country"
import * as Yup from "yup"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { useNavigate } from "react-router-dom"
import programApi from "Api/programApi"
import UniversityApi from "Api/UniversityApi"

import { ToastContainer,toast } from 'react-toastify'

const AddProgram = () => {
  document.title = "Add Program"
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const ProgramInitialData = {
    programName: "",
    duration: "",
    level: "",
    eligibilityCriteria: "",
    totalSeats: "",
    tuitionFee: "",
    admissionFee: "",
    Scholarship: "",
    intakeYear: "",
    modeOfStudy: "",
    description: "",
    university: "",
    Institution: "",
  }

  const [programData, setProgramData] = useState(ProgramInitialData)

  const [errors, setErrors] = useState({})
  const handleProgramDataChange = (name, value) => {
    setProgramData({ ...programData, [name]: value })
    setErrors({ ...errors, [name]: "" })
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Program", link: "#" },
    { label: "Add Program", link: "#" },
  ]
  const typeOptions = [
    { name: "underGraduate", code: "underGraduate" },
    { name: "postGraduate", code: "postGraduate" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]
  const modeofStudyOptions = [
    { name: "Online", code: "Online" },
    { name: "Offline", code: "Offline" },
    { name: "Hybrid", code: "Hybrid" },
  ]
  const [uniMenu, setUniMenu] = useState([])
  const universityDropDown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniMenu(res.data.university)
      })
      .catch(error => {
        console.log(error)
      })
  }
  useEffect(() => {
    universityDropDown()
  }, [accessToken])

  const [instituteMenu, setInstituteMenu] = useState([])
  const fetchInstituteByUniId = universityCode => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
    UniversityApi.getCollegesByUniversity(universityCode, config)
      .then(res => {
        setInstituteMenu(res.data.colleges)
      })
      .catch(error => {
        console.log(error)
      })
  }

  const ValidateProgram = Yup.object().shape({
    programName: Yup.string().required(" Program name is required "),
    duration: Yup.string().required("Duration is required"),
    level: Yup.string().required("Level is required"),
    eligibilityCriteria: Yup.string().required(
      "Eligibility criteria is required",
    ),
    totalSeats: Yup.date()
      .typeError("Invalid Total Seats")
      .required("Total seats are required"),
    tuitionFee: Yup.date()
      .typeError("Invalid Tution Fee")
      .required("Tution fee is required"),
    admissionFee: Yup.string().required("Admission fee is required"),
    Scholarship: Yup.string().required("Scholorship is required"),
    intakeYear: Yup.number()
      .typeError("Invalid Year")
      .min(1900, "Year cannot be less than 1900")
      .max(new Date().getFullYear(), "Year cannot be in the future")
      .required("Intake Year fee is required"),
    modeOfStudy: Yup.string()
      .oneOf(["online", "offline", "hybrid"], "Invalid Mode of Study")
      .required("Mode of study  is required"),
    description: Yup.string().required("Description is required"),
    university: Yup.string().required("University is required"),
    Institution: Yup.string().required("Institution is required"),
  })

  const addProgram = () => {
    const payload = {
      ...programData,
      university: programData?.university?._id,
      Institution: programData?.Institution?._id,
      modeOfStudy: programData?.modeOfStudy?.name?.toLowerCase(),
      Scholarship: programData?.Scholarship,
    }

    setLoading(true)

    ValidateProgram.validate(payload, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
        programApi
          .addProgram(payload, config)
          .then(res => {
            if (res.data.status) {
              setLoading(false)
              setTimeout(() => {
                navigate("/programlist")
              }, 1000)
              toast.success(res.data.message)

             
            }
          })
          .catch(error => {
            setLoading(false)
            toast.error(error?.response?.data?.message) 

            console.log(error)
          })
      })
      .catch(err => {
        setLoading(false)

        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
      })
  }

  return (
    <div className="add-Program">
      <ToastContainer  />
      <Row>
        <Col xs="12">
          <div className="program-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Add Program" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="program-add-form ">
                <div className="program-add-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={programData.university}
                      onChange={e => {
                        handleProgramDataChange("university", e.value)
                        fetchInstituteByUniId(e.value.universityCode)
                      }}
                      options={uniMenu}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="Institution">Institution</label>

                  <div className="inp-err">
                    <Dropdown
                      value={programData.Institution}
                      onChange={e => {
                        handleProgramDataChange("Institution", e.value)
                      }}
                      options={instituteMenu}
                      optionLabel="institutionName"
                      placeholder="Select Institution"
                      filter
                    />
                    {errors.Institution && (
                      <small className="error">{errors.Institution}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="ProgramName" className="label">
                    Program Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="ProgramName"
                      value={programData.programName}
                      onChange={e =>
                        handleProgramDataChange("programName", e.target.value)
                      }
                      placeholder="Enter Program Name"
                      className="inp-field-box"
                    />
                    {errors.programName && (
                      <small className="error">{errors.programName}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="duration"
                      value={programData.duration}
                      onChange={e =>
                        handleProgramDataChange("duration", e.target.value)
                      }
                      placeholder="Enter Duration"
                      className="inp-field-box"
                    />
                    {errors.duration && (
                      <small className="error">{errors.duration}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="level"
                      value={programData.level}
                      onChange={e =>
                        handleProgramDataChange("level", e.target.value)
                      }
                      placeholder="Enter Level"
                      className="inp-field-box"
                    />
                    {errors.level && (
                      <small className="error">{errors.level}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="EligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="eligibilityCriteria"
                      value={programData.eligibilityCriteria}
                      onChange={e =>
                        handleProgramDataChange(
                          "eligibilityCriteria",
                          e.target.value,
                        )
                      }
                      placeholder="Enter EligibilityCriteria"
                      className="inp-field-box"
                    />
                    {errors.eligibilityCriteria && (
                      <small className="error">
                        {errors.eligibilityCriteria}
                      </small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalSeats"
                      value={programData.totalSeats}
                      onChange={e =>
                        handleProgramDataChange("totalSeats", e.target.value)
                      }
                      placeholder="Enter TotalSeats"
                      className="inp-field-box"
                    />
                    {errors.totalSeats && (
                      <small className="error">{errors.totalSeats}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="tuitionFee"
                      value={programData.tuitionFee}
                      onChange={e =>
                        handleProgramDataChange("tuitionFee", e.target.value)
                      }
                      placeholder="Enter TuitionFee"
                      className="inp-field-box"
                    />
                    {errors.tuitionFee && (
                      <small className="error">{errors.tuitionFee}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="admissionFee"
                      value={programData.admissionFee}
                      onChange={e =>
                        handleProgramDataChange("admissionFee", e.target.value)
                      }
                      placeholder="Enter AdmissionFee"
                      className="inp-field-box"
                    />
                    {errors.admissionFee && (
                      <small className="error">{errors.admissionFee}</small>
                    )}
                  </div>
                </div>
                <div className="program-add-inp">
                  <label htmlFor="Scholarship" className="label">
                    Scholarship
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="Scholarship"
                      value={programData.Scholarship}
                      onChange={e =>
                        handleProgramDataChange("Scholarship", e.target.value)
                      }
                      placeholder="Enter Scholarship"
                      className="inp-field-box"
                    />
                    {errors.Scholarship && (
                      <small className="error">{errors.Scholarship}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="intakeYear" className="label">
                    IntakeYear
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="intakeYear"
                      value={programData.intakeYear}
                      onChange={e =>
                        handleProgramDataChange("intakeYear", e.target.value)
                      }
                      placeholder="Enter IntakeYear"
                      className="inp-field-box"
                    />
                    {errors.intakeYear && (
                      <small className="error">{errors.intakeYear}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="modeOfStudy">Mode Of Study</label>
                  <div className="inp-err">
                    <Dropdown
                      id="modeOfStudy"
                      value={programData.modeOfStudy}
                      onChange={e =>
                        handleProgramDataChange("modeOfStudy", e.value)
                      }
                      optionLabel="name"
                      options={modeofStudyOptions}
                      placeholder=" Select Mode of Study"
                    />
                    {errors.modeOfStudy && (
                      <small className="error">{errors.modeOfStudy}</small>
                    )}
                  </div>
                </div>
                <div className="program-add-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={programData.description}
                      onChange={e =>
                        handleProgramDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    addProgram()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AddProgram
